import { useModalStore } from "@/stores/use-modal-store";
import { ClassificationList } from "../components/classification-list";

/* Prop Types */
interface SelectClassificationModalProps {
  onClassificationSelect: (value: string) => void;
  studyType: "asset" | "scene";
}

/*
 * SelectClassificationModal component
 * This component is used to select a classification before drawing regions
 * The selected classification will be used for all subsequent drawings until changed
 */
export const SelectClassificationModal = ({ onClassificationSelect, studyType }: SelectClassificationModalProps) => {
  const { close } = useModalStore((state) => state.modalActions);

  const handleSelect = (value: string) => {
    onClassificationSelect(value);
    close();
  };

  return <ClassificationList handleClassificationSelect={handleSelect} studyType={studyType} />;
};
